import { render } from "./NotificationElement.vue?vue&type=template&id=e1f49202&scoped=true"
import script from "./NotificationElement.vue?vue&type=script&lang=js"
export * from "./NotificationElement.vue?vue&type=script&lang=js"

import "./NotificationElement.vue?vue&type=style&index=0&id=e1f49202&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FNotificationElement.vue&external"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/elements/notification.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FNotificationElement.vue&external"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f49202"]])

export default __exports__